export const APP_STORE_URL =
	"https://apps.apple.com/gt/app/padel-tenis-tracker-racketly/id6736381821";

export const GOOGLE_PLAY_URL =
	"https://play.google.com/store/apps/details?id=com.avilatek.racketly";

const APP_STORE_PROVIDER_TOKEN =
	process.env.REACT_APP_APP_STORE_PROVIDER_TOKEN?.trim();

export const APP_STORE_LANDING_URL = APP_STORE_PROVIDER_TOKEN
	? `${APP_STORE_URL}?pt=${encodeURIComponent(APP_STORE_PROVIDER_TOKEN)}&ct=racketly_landing&mt=8`
	: APP_STORE_URL;

const GOOGLE_PLAY_LANDING_REFERRER = new URLSearchParams({
	utm_source: "racketly.pro",
	utm_medium: "website",
	utm_campaign: "download_page",
}).toString();

export const GOOGLE_PLAY_LANDING_URL =
	`${GOOGLE_PLAY_URL}&referrer=${encodeURIComponent(GOOGLE_PLAY_LANDING_REFERRER)}`;
